module.exports = __webpack_public_path__ + "static/media/jointer-logo.78f762bd.png";